const productQuantityRetailItems = document.querySelectorAll('.product-quantity-retail-item')
productQuantityRetailItems.forEach((item) => {
    item.addEventListener('click', (e) => {
        if(!item.classList.contains('active')){
            productQuantityRetailItems.forEach((el) => {
                el.classList.remove('active')
            })
            item.classList.add('active')
            if (typeof setStickyButton === "function") {
                setStickyButton(item)
            }
        }
    })
})

const productQuantitySelection = document.querySelector('.product-quantity-selection')
const productSetBulkButton = document.querySelector('.product-quantity-set-bulk')
const productSetretailButton = document.querySelector('.product-quantity-set-retail')
const productRetail = document.querySelector('.product-quantity-retail')
const productBulk = document.querySelector('.product-quantity-bulk')
productSetBulkButton.addEventListener('click', (e) => {
    $(productRetail).slideUp()
    $(productBulk).slideDown()
    productQuantitySelection.classList.add('bulk')
    if (typeof setStickyButtonMode === "function") {
        setStickyButtonMode('bulk')
    }
})
productSetretailButton.addEventListener('click', (e) => {
    $(productRetail).slideDown()
    $(productBulk).slideUp()
    productQuantitySelection.classList.remove('bulk')
    if (typeof setStickyButtonMode === "function") {
        setStickyButtonMode('retail')
    }
})



const l2UsersSwiper = new Swiper("#l2-users-swiper", {
    spaceBetween: 0,
    slidesPerView: 1,
    pagination: {
        el: ".users-swiper-pagination",
    },
    breakpoints: {
        1100: {
            slidesPerView: 3,
        },
        800: {
            slidesPerView: 2,
        },
    },
})

const swiperHintLottie = document.getElementById('swiper-hint-lottie');
const productSliderThumb = new Swiper(".product-slider-thumbnails", {
    spaceBetween: 8,
    slidesPerView: 6,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
      900: {
        spaceBetween: 10,
        slidesPerView: 7,
        allowTouchMove: false,
      },
    }
});

//const effectsBanner = document.querySelector('.effects-banner')
const productSlider = new Swiper(".product-slider", {
    effect: 'fade',
    allowTouchMove: true,
    loop: true,
    fadeEffect: {
      crossFade: true
    },
    thumbs: {
        swiper: productSliderThumb,
    },
    breakpoints: {
        1100: {
            navigation: {
            nextEl: ".product-swiper-button-next",
            prevEl: ".product-swiper-button-prev",
            },
        },
    },
    on: {
        slideChange: function () {
            swiperHintLottie.stop();
            console.log('stoped');
        }
    }
});


// const wibButton = document.querySelector('.product-whats-in-the-box-button')
// const wibPopup = document.querySelector('.product-whats-in-the-box-popup')
// wibButton.addEventListener('click', (e) => {
//     wibPopup.classList.toggle('open')
// })

// document.addEventListener('click', (e) => {
//     if( e.target != wibButton && !e.target.closest('.product-whats-in-the-box-popup') ){ 
//         wibPopup.classList.remove('open')
//     }
// })


const productBulkQtMinusButton = document.querySelector('.product-quantity-bulk-minus')
const productBulkQtPlusButton = document.querySelector('.product-quantity-bulk-plus')
const productQuantityBulkInput = document.querySelector('.product-quantity-bulk-input')
const productQuantityBulkUnitsCount = document.querySelector('.product-quantity-bulk-units-qt')
const productQuantityBulkUnitsDiscountBadge = document.querySelector('.product-quantity-bulk-units-discount-badge')
const productQuantityBulkUnitPriceValue = document.querySelector('.product-quantity-bulk-unit-price-value')
const productQuantityBulkItemPrice = document.querySelector('.product-quantity-bulk-item-price')
const productAddToCartButton = document.querySelector('.product-item-add-to-cart')
const productQuantityBulkUnitPriceValueOriginal = document.querySelector('.product-quantity-bulk-unit-price-per-unit-original')
const productQuantityBulkBadgeProfit = document.querySelector('.product-quantity-bulk-badge-profit')

productBulkQtMinusButton.addEventListener('click', (e) => {
    let inputValue = parseInt(productQuantityBulkInput.value)
    if( inputValue > 4 ){
        inputValue--
        productQuantityBulkInput.value = inputValue
    }else{
        productBulkQtMinusButton.disabled = true
    }
    setProductQuantityBulk()
})

productBulkQtPlusButton.addEventListener('click', (e) => {
    let inputValue = parseInt(productQuantityBulkInput.value) + 1
    productQuantityBulkInput.value = inputValue
    if(inputValue > 4){
        productBulkQtMinusButton.disabled = false
    }
    setProductQuantityBulk()
})

const productAddToCartButtons = document.querySelectorAll('.product-item-add-to-cart')
productAddToCartButtons.forEach((productAddToCartButton) => {
    productAddToCartButton.addEventListener('click', (e) => {
        let currentProductEl = document.getElementById('product-luminette-2')
        const cartSidebar = document.getElementById('cart-sidebar')
        const l2BulkInput = document.getElementById('luminette-2-bulk-variation')
        if( currentProductEl !== null ){
            addProduct(currentProductEl)
            cartSidebar.classList.add('step-2')
            let productQuantity = 1
            if(productQuantitySelection.classList.contains('bulk')){
                productQuantity = productQuantityBulkInput.value
                
                l2BulkInput.value = productQuantity

                setBulkMode(currentProductEl, true)
                bulkImageVariant(currentProductEl)
                setUnitsQuantity()
                
            }else{
                setBulkMode(currentProductEl, false)
                let curSelectedRetailQuantityEl = document.querySelector('.product-quantity-retail-item.active')
                if(curSelectedRetailQuantityEl){
                    productQuantity = curSelectedRetailQuantityEl.dataset.productQuantity
                }
                let curActive = currentProductEl.querySelector('.item-variation.active')
                if(curActive){
                    curActive.classList.remove('active')
                }
                currentProductEl.querySelector('.item-variation[data-quantity="'+productQuantity+'"]').classList.add('active')
                setUnitsQuantity()
                
            }

            toggleMinimized(currentProductEl, false)
            
            changeColorVariationImage(currentProductEl)
            saveState()
            discounts()
            
            
            window.setTimeout(function(){
                document.body.classList.add('sidebar-open')
            }, 200);

            if(productAddToCartButton.classList.contains('sticky-button-el')){
                e.stopPropagation()
            }
        }
    })
})


function setProductQuantityBulk(){
    let quantity = parseInt(productQuantityBulkInput.value)
    productQuantityBulkUnitsCount.innerHTML = quantity
    let curDiscountAmount = null
    if(quantity <= 24){
        curDiscountAmount = productDiscountAmounts[quantity]
    }else{
        curDiscountAmount = productDiscountAmounts[24]
    }
    productQuantityBulkUnitsDiscountBadge.innerHTML = '-'+curDiscountAmount+'%'
    let basePrice = parseInt(productQuantityBulkItemPrice.dataset.basePrice)
    let pricePerUnit = parseInt( basePrice * ( 100 - curDiscountAmount ) / 100 )
    let priceTotal = parseInt( basePrice * quantity * ( 100 - curDiscountAmount ) / 100 )
    productQuantityBulkItemPrice.innerHTML = getPromotionalPrice(priceTotal).toFixed()
    productQuantityBulkUnitPriceValue.innerHTML = getPromotionalPrice(pricePerUnit).toFixed()
   
    let profit = basePrice * quantity - priceTotal
    productQuantityBulkBadgeProfit.innerHTML = profit

    if(productQuantityBulkUnitPriceValueOriginal){
        productQuantityBulkUnitPriceValueOriginal.innerHTML = priceTotal.toFixed()
    }
    if (typeof setStickyButtonBulk === "function") {
        setStickyButtonBulk()
    }
}




$("#show-more-section").click(function(){
    $(".show-more-wrp").slideDown('fast');
    $(".show-more-button-wrp").slideUp('fast');
});


const popupZoomInner = document.querySelector('.popup-zoom-inner img')
if(popupZoomInner){
    let aspect = 1
    let imageWidth
    let windowWidth
    popupStarter = document.querySelector('.l2-wib-image-wrp-mobile')
    popupStarter.addEventListener('click', (e) => {
        imageWidth = popupZoomInner.getBoundingClientRect().width
        windowWidth = window.innerWidth
    })
    
    let clientX;
    let clientY;
    popupZoomInner.addEventListener("touchstart", (e) => {
            clientX = e.touches[0].clientX;
            clientY = e.touches[0].clientY;
    }, false, );
    
    popupZoomInner.addEventListener('touchmove', function (e) {
        let deltaX = e.changedTouches[0].clientX - clientX;
        let style = window.getComputedStyle(popupZoomInner)
        let transform = new WebKitCSSMatrix(style.transform).m41
        let newTransform = transform + deltaX * aspect
        if( Math.abs( newTransform ) < (imageWidth - windowWidth) / 2 ){
            popupZoomInner.style.transform = "translateX(" + newTransform + "px)";    
        }
        
    })
   
}



const l2RoutineImage = document.querySelector('.l2-routine-image')
const l2RoutineButtons = document.querySelectorAll('.l2-routine-select')
const l2RoutineWrp = document.querySelector('.l2-routine-image')
if(l2RoutineButtons){
    l2RoutineButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
            l2RoutineWrp.classList.add('paused')
            l2RoutinePause()
            let imageID = button.dataset.image
            selectL2Routine(imageID)
        })
    })

    function l2RoutinePause(){
        setTimeout(function(){
            l2RoutineWrp.classList.remove('paused');
        }, 2000)
    }

    setInterval(() => {
        if( !l2RoutineWrp.classList.contains('paused') ){ // !l2RoutineImage.matches(':hover')
            let buttons = document.querySelectorAll('.l2-routine-select')
            let curButton = document.querySelector('.l2-routine-select.active')
            let curImageID = curButton.dataset.image
            let curIndex = curImageID.substring( curImageID.length - 1)
 
            if( curIndex == 1  ){
                curIndex = buttons.length
            }else{
                curIndex--
            }
            selectL2Routine('l2-routine-image-'+curIndex)
        }
    }, 2500)
}



function selectL2Routine(imageID){
    let imageEl = document.getElementById(imageID)
    if(imageEl){
        let down = document.querySelectorAll('.l2-routine-select.down')
        if(down){
            down.forEach((downEl) => {
                downEl.classList.remove('down')
            })
        }
        document.querySelector('.l2-routine-image-item.active').classList.remove('active')
        document.querySelector('.l2-routine-select.active').classList.remove('active')
        imageEl.classList.add('active')
        let button = document.querySelector('.l2-routine-select[data-image="'+imageID+'"]')
        if(button){
            button.classList.add('active')
        }
        let hiddenData = button.dataset.hideOn
        if(hiddenData){
            let hiddenArray = JSON.parse(hiddenData)
            if(hiddenArray){
                hiddenArray.forEach((i) => {
                    //console.log(l2RoutineButtons[ i - 1 ]);
                    l2RoutineButtons[ i - 1 ].classList.add('down')
                })
            }
        }
    }
}

